var map = {
	"./elixir-arsign-img-1.jpg": 134,
	"./elixir-branding-img-1.jpg": 220,
	"./elixir-brochur-img-1.jpg": 135,
	"./elixir-digital-img-1.jpg": 136,
	"./elixir-exhibitions-img-1.jpg": 137,
	"./elixir-gifts-img-1.jpg": 138,
	"./elixir-label-img-1.jpg": 139,
	"./elixir-packaging-img-1.jpg": 140,
	"./elixir-printing-img-1.jpg": 141,
	"./elixir-restaurant-img-1.jpg": 142,
	"./elixir-safety-img-1.jpg": 143,
	"./elixir-signages-img-1.jpg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;